import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';
import { BaseComponent } from '@shared/component/base/base.component';

@Component({
  selector: 'app-subscription-banner-upgrade',
  templateUrl: './subscription-banner-upgrade.component.html',
  styleUrls: ['./subscription-banner-upgrade.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerUpgradeComponent extends BaseComponent {
  private dialog = inject(MatDialog);

  openSubscriptionDialog(): void {
    this.dialog.open(SubscriptionChangeDialogComponent, {
      panelClass: 'dialog-extra-large'
    });
  }
}
